<template lang="html">
  <section
  
    class="banner-app column-start banner-juntas  "
    :type="navigationtype"
    :show="canishow && show" 
  >
   
    <a @click="show = false" class="cerrar">✕</a>

    <div class="text-pop-up">
      <!-- <h2 v-html="$t('popupretenes.title')"></h2> -->
      <!-- <span v-html="$t('popupjuntas.novedades')" class="title-novedades"></span> -->
      <h2 v-html="$t('popupjuntas.title')"></h2>
      <p v-html="$t('popupjuntas.texto')"></p>
      <span class="container-btn" @click="show = false"
        ><a
          :href="
            $t('enlaces.catalogo') + '#' + $t('catalogo.cat_juegoJuntas.idUrl')
          "
          class="btn-dark"
          v-html="$t('popupjuntas.boton')"
        >
         
        </a></span
      >
    </div>
    <!-- <h2 v-html="$t('popupretenes.title')"> </h2>

    <span @click="show = false"><router-link :to="$t('enlaces.catalogo')+'#retenes'" class="btn-dark">
      {{$t('popupretenes.boton')}}
    </router-link></span>

    <img src="/static/img/banner-retenes/retenes.webp" class="retenes" width="188" height="161" loading="lazy"> -->
  </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from 'vuex'
  export default  {
    name: 'banner-juntas',
    props: [],
    mounted() {
      if(this.canishow){
      this.cambiarBanner(1);
      }
      
      
    },
    data() {
      return{
        idbanner : 2,
        show : true
      }
    },
    methods : {
      ...mapActions(['cambiarBanner']),
      
    },
    computed : {
      
        ...mapGetters({
          navigationtype : 'getnavigationtype',
          canishow : 'getcanishow',
          lastBanner : 'getLastBanner'
        })
    }

  }
</script>

<style scoped>
.banner-app {
  position: fixed;
  right: 122px;
  bottom: -450px;
  z-index: 180;
  background-image: url("/static/img/banner-juntas/bg-pop-up.webp");
  background-repeat: no-repeat;
  background-size: cover;
  padding: 20px 60px;
  max-width: 480px;
  height: 100%;
  max-height: 240px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -o-flex-direction: column;
  flex-direction: column;
  align-items: center;
  justify-content: center;
 
}
.text-pop-up {
  background: #ffffffed;
  width: 100%;
  padding: 20px 55px;
  opacity: 0;
 
}
.title-novedades {
  color: #054279;
  font-size: 14px;
  position: relative;
}
.title-novedades::before {
  position: absolute;
  top: -3px;
  left: -9px;
  content: "";
  width: 10px;
  height: 10px;
  background-image: url(/static/img/banner-juntas/pico-decoracion.svg);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: top left;
}
.banner-app[show="true"] {
  transform: translateY(-450px);
   transition-timing-function: linear;
  transition-delay: 2s;
   transition: 0.8s;
}

.banner-app[show="true"] .text-pop-up {
  opacity: 1;
  transition-duration: 0.8s;
    transition-timing-function: linear;
    transition-delay: 2.5s;
  
}

h2 {
  text-transform: uppercase;
  margin-bottom: 5px;
  width: 100%;
  display: inline-block;
  font-size: 18px;
  line-height: 20px;
  margin-top: 10px;
  max-width: 230px;
  color: #054279;
  font-weight: bold;
}

p {
  font-size: 14px;
  color: #054279;
  line-height: 16px;
}

/* .contenedor-botones {
  width: 100%;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  -o-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-top: 20px;
}

.contenedor-botones a {
  margin: 0 10px;
} */
.container-btn {
  display: flex;
  align-content: center;
  justify-content: center;
}
.cerrar {
  position: absolute;
  top: -30px;
  right: 0;
  width: 30px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
}

.movil {
  position: absolute;
  right: -50px;
  top: -50px;
  pointer-events: none;
  transform: translate(300px, 300px);
  transition-delay: 1s;
}

[show="true"] .movil {
  transition: 1s;
  transition-delay: 2.5s;
  transform: translate(0px, 0px);
}

.btn-dark {
  text-transform: uppercase;
  font-size: 13px;
  padding: 5px 15px;
}

@media screen and (max-width: 768px) {
  .movil {
    display: none;
  }

  .banner-app {
    right: 0;
    width: 100%;
    max-width: 70%;
    box-shadow: 2px -3px 20px 0px #00000047;
    -webkit-flex-direction: row;
    -moz-flex-direction: row;
    -ms-flex-direction: row;
    -o-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: wrap;
    -moz-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    -o-flex-wrap: wrap;
    flex-wrap: wrap;
    -ms-align-items: flex-start;
    align-items: flex-start;
  }

  .logo-banner-app {
    margin-right: 10px;
  }

  h2 {
    max-width: 100%;
  }

  .contenedor-botones {
    width: auto;
    position: absolute;
    right: 35px;
    top: 5px;
  }

  .contenedor-botones a {
    display: none;
    margin: 0;
  }

  [type="android"] a[type="android"] {
    display: inline-block;
  }

  [type="ios"] a[type="ios"] {
    display: inline-block;
  }

  .cerrar {
    color: white;
    top: -29px;
  }

  .banner-app {
    height: auto;
  }

  .retenes {
    left: 20px;
    top: 20px;
    width: 120px;
  }
}

@media screen and (max-width: 600px) {
  .banner-app {
    padding: 20px;
    max-width: 100%;
  }
  .text-pop-up {
    padding: 20px 25px;
  }
}

@media screen and (max-width: 350px) {
  h2 {
    font-size: 14px;
    max-width: 130px;
    line-height: 16px;
  }

  .contenedor-botones {
    right: 35px;
    top: 0;
  }

  .btn-dark {
    font-size: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/banner-juntas.vue